const staticText = {
    en: {
      form: `Registration Form for Individuals / Professionals`,
      entita: `What kind of entity are you?`,
      persona: `Natural Person`,
      ditta: `Freelance / Individual Company`,
      italianResidence : `Does your company currently reside in Italy?`,
      yes:'Yes', 
      nome: 'Name',
      cognome: 'Surname',
      sesso: 'Gender',
      indirizzo: 'Address',
      numCiv: `N.`,
      codFiscale : `Tax Code`,
      country: `Country `,
      prov: `Province`,
      comune: `Municipality `,
      cap: `Zip Code`,
      cf:  `Tax Code`,
      luogoResid: `City`,
      tel: `Phone N.`,
      cell: `Mobile N.`,
      fax: `Fax`,
      pec: `Certified Email`,
      dataNascita: `Born on`,
      countryNascita: `Country of Birth`,
      provNascita : `Province of Birth`,
      comuneNascita: `Municipality of Birth`,
      luogoNascita: `Birth Place`,
      tipoDoc: `Type of Document`,
      numDoc: `N°`,
      dataDoc: `Date of Issue`,
      dataScadDoc: `Expiry Date`,
      rilascioDoc: `Issued by`,
      identityParagraph: `Enter the <b>identity document</b> details.`,
      identityTitolare: `<p>Enter the <b>identity document</b> details of the Beneficial Owner.</p>`,  
      docParagraph: `Attached Documents <b>(Max number of files: 4 - Identity Document - Tax Code)</b>`,
      format:  ` Allowed formats: PDF, DOC, PNG, and JPG, maximum size 5MB.`,
      drag: `Drag and drop one or more files here`,
      chooseDocs: `Choose files`,
      removeDocs: `Remove files`,
      ragSociale : `Business Name`,
      luogoDitta: `Business Place`,
      pIva: `VAT Code`,
      sottoscritto: `The undersigned`,
      informativaParagraph: `Dear Customer, this information is provided to customers, individuals and natural persons operating in the name and on behalf of juridical person, pursuant to article 13 GDPR
      679/2016 (European Regulation on the protection of personal data). `,
      informativaTitle: `INFORMATIVE REPORT DISCLOSURE PURSUANT TO ARTICLES 13 / 14 GDPR 679 / 2016
      (European Regulation on the protection of personal data)`,
      authorize: `I authorize the processing of personal data as per the Privacy Policy.`,
      racConsenso: `FORM FOR THE COLLECTION OF CONSENT FOR THE INTERESTED PARTY`,
      racConsensoParagraph: `Manifestation of consent to the treatment of personal data pursuant to the Article 7 of the European general regulation n.679 / 2016 relating to protection of individuals with
      regard to the processing of personal data. In relation to the Information provided by Casa delle Aste Meeting Art S.p.a., the undersigned declares to have read the Informative here attached in every points and to
      provide his / her manifestation of will regarding treatments of personal data which legal basis is the free and informed consent.`,
      allow: `I GIVE THE CONSENT`,
      deny: `I DO NOT GIVE THE CONSENT`,
      consensoA: `A) AUTHORIZATION TO SEND PROMOTIONAL NEWSLETTERS / ADVERTISING MATERIALS / PROMOTIONAL ACTIVITIES IN GENERAL (E-MAIL PROVIDED DURING REGISTRATION)`,
      consensoB1: `B) B1 - AUTHORIZATION TO SEND NOTICES RELATED TO MY OFFERS AND SUMMARIES RELATED TO MY PURCHASES VIA E-MAIL (E-MAIL PROVIDED DURING THE REGISTRATION)`,
      consensoB2: ` B) B2 - AUTHORIZATION TO SEND DOCUMENTS VIA E-MAIL (E-MAIL PROVIDED DURING THE REGISTRATION)`,
      privacyConsenso: `Consents are <u>optional</u>: I can revoke my consent declarations to Meeting Art S.p.a. at any time by sending an email to the address`,
      salesCheck1: `I expressly approve articles no. 2 (exception to the right of withdrawal), no. 3 (auction fees), no. 7 (payment of the price), and no. 16 (Disputes and waiver of consumer jurisdiction).`,
      salesCheck2: `I have read the Terms of Sale`,
      salesParagraph: `Please make sure to review all the sections below and check the boxes before proceeding with the form completion.`,
      sales: `Terms of Sale`,
      close: `Close all - `,
      open: `Open all + `,
      nonPep: ` <b><u>Not to be</u></b> a political exposed person`,
      pep: ` <b>To be</b> a political exposed person`,
      pepNazionale: ` (national or foreign)`,
      antiriciclaggio1 : `CUSTOMER DECLARATION FOR THE PURPOSE OF DUE DILIGENCE `,
      antiriciclaggio2 : `according to Legislative Decree no. 231/2007 as amended `,
      antiricParagraph: `In order to consent <b>MEETING ART SPA</b> to comply with due diligence according to art. 22 of the Legislative
Decree no. 231 / 2007 as amended (Customer obligation regarding the prevention and fight against`,
      riciclaggio : `money laundering`,
      terrorismo: `and terrorist financing) `,
      resp: `under his responsibility`,
      natoA:  `Born in`,
      compilazioneTitolare: `Fill in the fields below with the details of the Ultimate Beneficial Owner`,
      notTitolare: `To act in the name and on behalf of himself`,
      titolare: `To act in the name and on behalf of the following Beneficial Owner of the Transaction`,
      pepTitolare:`<b>The Ultimate Beneficial Owner is</b> a political exposed person`,
      nonPepTitolare:` <b>The Ultimate Beneficial Owner <u>isn’t</u></b> a political exposed person`,
      rapportoTitolare: `the nature of the relationship between the Customer and the Ultimate Beneficial Owner is`,
      dichiarazione: `-that the information provided in this form is correct, complete, and up-to-date\n
                      -to take full responsibility under civil, criminal, and administrative law for untruthful declarations, being aware of the criminal liabilities foreseen by Article 55 of Legislative Decree No. 231 of November 21, 2007, for those who provide false or untrue information\n
                      -to have been informed that the failure to provide all or part of the information contained in this form may hinder the auction house’s ability to carry out the requested service/operation\n
                      -to have reviewed and understood the definitions of Legislative Decree No. 231 of November 21, 2007, attached to this form\n
                      -to have received, read, and understood the information notice pursuant to Articles 13 and 14 of Regulation (EU) 2016/679 and to fully accept its content.\n`,
  
      impegno: `to promptly communicate any updates or changes to the above information.`,
      identification: `ID DOCUMENT`,
      dom: `Domicile Details `,
      abilita: `Enable Section`,  
      disabilita: `Disable Section`,        
      luogoDom: `Place of Domicile`,
      indirizzoDom: `Domicile Address`,
      domNotResid: `(Fill in if different from residence address)`,
      clienteTitolare : `CUSTOMER AND BENEFICIAL OWNER (select one of the two following possible options)`,
      infoProf:  `INFORMATION ON BUSINESS CUSTOMER`,
      rapporto:  `NATURE AND PURPOSE OF THE TRANSACTION`,
      profCli:  `That the profession / business activity of the Customer is`,
      tipRapporto:  `That the nature of the relationship / type of transaction is`,
      scRapporto:  `That the purpose of the relationship / transaction is`,
      dichiara: `Declares`,
      dichiara2:  `DECLARES ALSO`,
      impegna:  `UNDERTAKES`,
      impegno: `to communicate without delay any possible integration or variation of the data indicated above.`,
      luogoForm: `Form Completion Location`,  
      dataForm: `Form Completion Date`,  
      authCodePar1: `Once you click the "Send Authentication Code" button, a code will be sent to the email address `,  
      authCodePar2: `If you do not receive it, after checking your Spam folder, you can request a resend by clicking the button again.\n  
      WARNING: The generated code, once entered in the field below, will be considered as acceptance and signing of the registration form.`, 
      inviaCode:  `Send Authentication Code`,
      insertCode: `Insert the authentication code`,
      insertCode2: `Enter a 6-character authentication code.`,
      registrazione: `Registration successfully completed!`,
      success: `Thank you for completing the registration. You will be contacted within the next 48 hours at the number`,
      success2: `to receive an explanation of the participation conditions for our Auctions. <br/><b>WARNING:</b> This timeframe is not guaranteed on Saturday and Sunday Auction days.<br/><br/>At that point, your registration will be considered complete.</p>` ,
      avanti:  `Next`,
      indietro: `Back`,
      invia: `Submit`,
      home: `Return to Home`,
      selezionaStato: `Select a country`,
      selezionaProvincia: `Select a province`,
      selezionaComune: `Select a municipality`,
      insertCognome: `Enter the surname`,
      insertNome: `Enter the first name`,
      insertIndirizzo: `Enter the address`,
      insertNumeroCivico: `Enter the civic number`,
      insertCAP: `Enter the postal code`,
      insertLocalitaResidenza: `Enter the residence place`,
      insertLocalitaDomicilio: `Enter the domicile place`,
      insertNumeroTelefono: `Enter the phone number`,
      insertNumeroCellulare: `Enter the mobile number`,
      insertFax: `Enter the fax`,
      insertEmail: `Enter the email address`,
      insertEmailNews: `Enter the email address to receive newsletters`,
      insertPartitaIva: `Enter the VAT Code`,
      insertPEC: `Enter the certified email address`,
      insertLocalitaNascita: `Enter the place of birth`,
      insertCodiceFiscale: `Enter the tax code`,
      insertNumeroDocumento: `Enter the document number`,
      insertEnteRilascioDocumento: `Enter the issuing authority of the document`,
      insertLuogoCompilazione: `Enter the form completion location`,
      insertRagSoc :`Enter the business name`,
      insertTextPep: `Please specify the public office or the name and the relationship with the PEP in case of family members or individuals who have a close relationship with a PEP`,
      insertNatRapporto : `Specify the nature of the relationship`,
      insertTipRapporto :`Describe the nature of the contact`,
      insertScRapporto :`Describe the purpose of the contact`,

    },
    it: {
      form: `Form di Registrazione per Persone Fisiche / Professionisti e Ditte Individuali`,
      entita: `Che tipo di entità sei?`,
      persona: `Persona Fisica`,
      ditta: `Ditta Individuale`,
      italianResidence : `La tua Ditta risiede attualmente in Italia?`,
      yes:'Sì', 
      nome: 'Nome',
      cognome: 'Cognome',
      sesso: 'Sesso',
      indirizzo: 'Indirizzo di Residenza',
      numCiv: `N.`,
      codFiscale : `Cod.Fiscale`,
      country: `Stato `,
      prov: `Provincia`,
      comune: `Comune `,
      cap: `CAP`,
      luogoResid: `Luogo di Residenza`,
      tel: `Telefono`,
      cell: `Cellulare`,
      fax: `Fax`,
      pec: `P.E.C`,
      dataNascita: `Nato/a il`,
      countryNascita: `Stato di Nascita`,
      provNascita : `Provincia di Nascita`,
      comuneNascita: `Comune di Nascita`,
      luogoNascita: `Luogo di Nascita`,
      identityParagraph: `Inserire i dati del <b>documento d'identità</b>. Nel caso si tratti di Società o Ditte individuali, inserire i dati del documento d’identità del Legale Rappresentante.`,
      identityTitolare: `<p>Inserire i dati del <b>documento d'identità</b> del Titolare Effettivo.</p>`,
      tipoDoc: `Tipo Doc. d'Identità`,
      numDoc: `N°`,
      dataDoc: `Data di Rilascio`,
      dataScadDoc: `Data di Scadenza`,
      rilascioDoc: `Rilasciato da`,
      docParagraph: `Documenti Allegati <b>(Max numero di file: 4 - Carta d'identità e Codice Fiscale)</b> `,
      format:  ` Formati Consentiti: PDF, DOC, PNG e JPG, dimensione massima 5MB`,
      drag: `Trascina uno o più file qui`,
      chooseDocs: `Scegli i file`,
      removeDocs: `Rimuovi i file`,
      ragSociale : `Ragione Sociale`,
      luogoDitta: `Locazione della Ditta`,
      pIva: `Partita IVA`,
      sdi: `Codice Destinatario Univoco`,
      sdiCode: `Inserisci un codice alfanumerico di 7 caratteri.`,
      or: `Oppure`,
      pecDitta: `PEC (Posta Elettronica Certificata)`,
      privacyConsenso: `I consensi sono <u>facoltativi</u>: posso in ogni momento revocare le mie dichiarazioni di consenso a Meeting Art S.p.a. inviando una e-mail all’indirizzo`,
      informativaParagraph: `Gentile Cliente, la presente informativa viene resa ai clienti persone fisiche e alle persone fisiche che operano in nome e per conto dei clienti persone giuridiche, ai sensi dell’art.13 / 14 GDPR 679 / 2016 (Regolamento Europeo sulla protezione dei dati personali).`,
      informativaTitle: `INFORMATIVA A NORMA DEGLI ARTT. 13 / 14 GDPR 679 / 2016
      (Regolamento Europeo sulla protezione dei dati personali)`,
      authorize: `Autorizzo il trattamento dei dati personali come da Informativa`,
      racConsenso: `RACCOLTA DEL CONSENSO PRESSO L’INTERESSATO`,
      racConsensoParagraph: `Manifestazione di consenso al trattamento dei dati personali ai sensi dell/’articolo 7 del regolamento generale europeo n.679 / 2016 relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali. In relazione all’Informativa fornitagli dalla Casa delle Aste Meeting Art S.p.a, il sottoscritto dichiara di aver letto e compreso l’informativa allegata in ogni punto e di fornire la propria manifestazione di volontà in merito ai trattamenti la cui base giuridica è il consenso libero ed informato.`,
      sottoscritto: `Il sottoscritto`,
      cf: `C.F.`,
      allow: `PRESTO IL CONSENSO`,
      deny: `NEGO IL CONSENSO`,
      consensoA: `A) AUTORIZZO ALL’INVIO DI NEWSLETTER PROMOZIONALI / MATERIALE PUBBLICITARIO / ATTIVITA’ PROMOZIONALI IN GENERE (E-MAIL FORNITA IN FASE DI REGISTRAZIONE)`,
      consensoB1: `B)  B1 - AUTORIZZO ALL’INVIO DI NOTIFICHE RELATIVE ALLE MIE OFFERTE E RIEPILOGHI RELATIVI AI MIEI ACQUISTI VIA E-MAIL (E-MAIL FORNITA IN FASE DI REGISTRAZIONE)`,
      consensoB2: `B) B2 - AUTORIZZO ALL’INVIO DI DOCUMENTI A ME INTESTATI (ES. FATTURE) VIA E-MAIL(E-MAIL FORNITA IN FASE DI REGISTRAZIONE)`,
      salesCheck1: `Si approvano espressamente gli articoli n. 2 (eccezione al diritto di recesso), n. 3) (commissioni d’asta), n. 7) (pagamento del prezzo) e n.16) (Controversie e deroga al foro del consumatore).`,
      salesCheck2: `Ho letto le Condizioni di Vendita`,
      salesParagraph: `Si prega di visionare obbligatoriamente tutti i paragrafi sottostanti e di apporre una spunta sulle caselle prima di proseguire con la compilazione del form.`,
      sales: `Condizioni di Vendita`,
      close: `Chiudi tutto - `,
      open: `Apri tutto + `,
      natoA:  `Nato a`,
      nonPep: ` <b>Di <u>non</u> essere</b> persona politicamente esposta`,
      pep: ` <b>Di essere</b> persona politicamente esposta `,
      pepNazionale: `(nazionale o estera)`,
      antiriciclaggio1 : `DICHIARAZIONE AI FINI DELLA NORMATIVA ANTIRICICLAGGIO `,
      antiriciclaggio2 : `D. Lgs 231/2007 e successive modifiche `,
      antiricParagraph: `Al fine di consentire a <b>MEETING ART SPA</b> di ottemperare agli obblighi di adeguata verifica della clientela,
          e comunque in ottemperanza alle disposizioni dell’art. 22 del Decreto Legislativo del 21 novembre
          2007 n. 231 e ss. mm. (Obblighi del cliente in materia di prevenzione e contrasto al&nbsp;`,
      riciclaggio : `riciclaggio`,
      terrorismo: `e al finanziamento del terrorismo) `,
      resp: `sotto la sua responsabilità`,
      dom: `  Dati di Domicilio `,
      abilita : `Abilita Sezione`,
      disabilita : `Disabilita Sezione`,
      luogoDom: `Luogo di Domicilio`,
      indirizzoDom : `Indirizzo di Domicilio`,
      domNotResid: `(Compilare se diversi da quelli di residenza)`,
      identification: `Identificato / a Mediante`,
      clienteTitolare : `CLIENTE / TITOLARE EFFETTIVO (selezionare una delle due opzioni seguenti)`,
      notTitolare: `Di agire in nome e per conto proprio`,
      titolare: `Di agire in nome e per conto di (Titolare Effettivo dell’ Operazione)`,
      pepTitolare:`<b>Il Titolare Effettivo costituisce</b> persona politicamente esposta`,
      nonPepTitolare:` <b>Il Titolare Effettivo <u>non</u> costituisce</b> persona politicamente esposta`,
      rapportoTitolare: `e che la natura della relazione tra Cliente e Titolare Effettivo è:`,
      compilazioneTitolare : `Compilare i campi sottostanti con i dati del Titolare Effettivo dell'operazione.`,
      infoProf:  `INFORMAZIONI SU ATTIVITÀ ECONOMICA / PROFESSIONE DEL CLIENTE`,
      rapporto:  `NATURA E SCOPO DELLA PRESTAZIONE / OPERAZIONE`,
      profCli:  `Che la professione / attività economica del Cliente è`,
      tipRapporto:  `Che la natura del rapporto / tipologia di prestazione resa dalla casa d’aste è`,
      scRapporto:  `Che lo scopo del rapporto / operazione è`,
      dichiara: `Dichiara`,
      dichiara2:  `DICHIARA ALTRESÌ`,
      impegna:  `SI IMPEGNA`,
      luogoForm:  `Luogo Compilazione Form`,
      dataForm:  `Data Compilazione Form`,
      dichiarazione: `-che le informazioni fornite nel presente Modulo sono corrette, complete ed aggiornate\n
                      -di assumere ogni responsabilità sotto il profilo civile, penale ed amministrativo per dichiarazioni non veritiere, consapevole delle responsabilità penali previste all’art. 55 del Decreto Legislativo del 21 novembre 2007 n. 231 per chi fornisce dati falsi o informazioni non veritiere\n
                      -di essere stato informato della circostanza che il mancato rilascio di tutto o parte delle informazioni contenute nel presente modulo pregiudica la possibilità della casa d’aste di dare esecuzione alla prestazione / operazione richiesta\n
                      -di aver esaminato e compreso le definizioni del Decreto Legislativo del 21 novembre 2007 n. 231 che si trovano allegate al presente Modulo\n
                      -di aver ricevuto, letto e compreso l’informativa ex artt.13 e 14 del Regolamento (UE) 2016 / 679 e di accettarne integralmente il contenuto.\n`,
  
      impegno: `a comunicare senza ritardo ogni eventuale integrazione o variazione dei dati sopra indicati.`,
      authCodePar1:  `Una volta premuto sul pulsante “Invia codice di autenticazione” verrà inviato un codice alla e-mail `,
      authCodePar2:  `In caso di mancata ricezione, dopo aver controllato nella cartella di Posta Indesiderata, è possibile effettuare un re-invio premendo nuovamente il pulsante.\n
      ATTENZIONE: Il codice generato e successivamente inserito nel campo sottostante verrà considerato come accettazione e sottoscrizione del form di registrazione.`,
      inviaCode:  `Invia codice di autenticazione`,
      insertCode: `Inserisci il codice di autenticazione`,
      insertCode2: `Inserisci un codice di autenticazione di 6 caratteri.`,
      registrazione : `Registrazione effettuata con successo!`,
      success: `Grazie per aver completato la registrazione, verrà contattato/a nell’arco delle prossime 48 ore al numero`,
      success2: ` affinchè le vengano spiegate le condizioni di partecipazione alle nostre Aste. <br/><b>ATTENZIONE:</b> questa tempistica non è garantita nelle giornate d'Asta di Sabato e Domenica.<br/><br/>A quel punto la sua registrazione potrà considerarsi effettiva.</p>`,
      avanti:  `Avanti`,
      indietro: `Indietro`,
      invia: `Invia`,
      home: `Torna alla Home`,
      selezionaStato: `Seleziona uno stato`,
      selezionaProvincia: `Seleziona una provincia`,
      selezionaComune: `Seleziona un comune`,
      insertCognome: `Inserisci il cognome`,
      insertNome: `Inserisci il nome`,
      insertIndirizzo: `Inserisci l'indirizzo`,
      insertNumeroCivico: `Inserisci il numero civico`,
      insertCAP: `Inserisci il CAP`,
      insertLocalitaResidenza: `Inserisci la località di residenza`,
      insertLocalitaDomicilio: `Inserisci la località di domicilio`,
      insertNumeroTelefono: `Inserisci il numero di telefono`,
      insertNumeroCellulare: `Inserisci il numero di cellulare`,
      insertFax: `Inserisci il fax`,
      insertEmail: `Inserisci l'indirizzo email`,
      insertEmailNews: `Inserisci l'indirizzo email per ricevere le newsletters`,
      insertPartitaIva: `Inserisci la partita IVA`,
      insertPEC: `Inserisci l'indirizzo P.E.C`,
      insertLocalitaNascita: `Inserisci la località di nascita`,
      insertCodiceFiscale: `Inserisci il codice fiscale`,
      insertNumeroDocumento: `Inserisci il numero del documento`,
      insertEnteRilascioDocumento: `Inserisci l'ente che ha rilasciato il documento`,
      insertLuogoCompilazione: `Inserisci il luogo di compilazione del form`,
      insertTextPep: `Indicare la carica pubblica ovvero il nome e il legame con il PEP nel caso di familiari o soggetti che con il medesimo intrattengono stretti legami`,
      insertNatRapporto : `Specificare la natura della relazione`,
      insertTipRapporto :`Descrivi la natura del rapporto`,
      insertScRapporto :`Descrivi lo scopo del rapporto`,
      insertRagSoc :`Inserisci la ragione sociale`,


    },
  };
  
  export default staticText;
  
